import React from 'react';

const NotFound = () => {
    return (
        <div className="container">
            <h2 className="text-center Text-muted"> <sapn className="text-danger">404</sapn>  Page Not Found</h2>
        </div>
    );
};

export default NotFound;